module.exports = __webpack_public_path__ + "img/23.e5e05f3b.png";